import { AskRequest, AskRequestStatus } from '@hone-automation/common';
import { useRecategorizeQueueRequestMutation } from 'hooks/queue';
import { useQueueContext } from 'presentation/components/Queue/QueueContext';
import { useEvent } from './useEvent';
import { UIFlaggedTransaction } from 'types/askcustomer';

/**
 * Custom hook for recategorizing requests
 * Extracts logic from the withQueue HOC in QueueReCategorizeButton
 */
export function useRecategorize(txId: string, locationId: string, activeTab: AskRequestStatus) {
  const { dispatch } = useQueueContext();
  const { dispatch: emitEvent } = useEvent('onQueueRequestResolve');

  const reCategorizeTransaction = useRecategorizeQueueRequestMutation(
    locationId,
    activeTab,
    (trx: UIFlaggedTransaction | undefined, data: AskRequest) => {
      // Use the data parameter (AskRequest) which comes as a second parameter from the API
      if (!data) return;

      // Ensure the data object has all required AskRequest properties
      const typedData = data as AskRequest;

      // If the status has changed, provide message about viewing in different tab
      const statusChanged = data.status !== activeTab;

      dispatch({
        type: 'UPDATE_REQUEST',
        payload: {
          request: data,
          status: data.status,
        },
      });

      dispatch({ type: 'SET_SELECTED_ITEM', payload: data });

      emitEvent({
        field: data.status,
        duration: 5000,
        message: statusChanged
          ? `Request status updated to ${data.status}. Go to ${data.status} tab to view it.`
          : undefined,
      });
    }
  );

  const recategorize = async (formData: { comment: string; account: string }) => {
    reCategorizeTransaction.mutate({
      trxId: txId,
      newAccountId: formData.account,
      comment: formData.comment,
    });
  };

  return {
    isPending: reCategorizeTransaction.isPending,
    recategorize,
  };
}
